import { useEffect, useMemo, useState } from 'react';
import { fetchTasksForGroup } from '../../../Service/restapi/taskService';
import { TaskField } from './TaskField';
import { Accordion, Button, Stack, Text } from '@mantine/core';
import { IconChevronRight } from '@tabler/icons';

export const TaskGroup = ({ group, entityId, lastModified }) => {
  const [tasks, setTasks] = useState();
  const [showCompleted, setShowCompleted] = useState(false);

  const { id, name } = group;

  const sortedTasks = useMemo(() => {
    if (!tasks) {
      return [];
    }

    return [...tasks].sort((firstTask, secondTask) => {
      const firstCompletedOrder = firstTask.completed ? 1 : 0;
      const secondCompletedOrder = secondTask.completed ? 1 : 0;

      if (firstCompletedOrder !== secondCompletedOrder) {
        return firstCompletedOrder - secondCompletedOrder;
      }

      const firstDueDate = firstTask.dueDate ? new Date(firstTask.dueDate).getTime() : Number.MAX_SAFE_INTEGER;
      const secondDueDate = secondTask.dueDate ? new Date(secondTask.dueDate).getTime() : Number.MAX_SAFE_INTEGER;

      if (firstDueDate !== secondDueDate) {
        return firstDueDate - secondDueDate;
      }

      return firstTask.name.localeCompare(secondTask.name);
    });
  }, [tasks]);

  const completedTasks = sortedTasks.filter((task) => task.completed);
  const visibleTasks = showCompleted ? sortedTasks : sortedTasks.filter((task) => !task.completed);
  const completedTasksCount = completedTasks.length;

  useEffect(() => {
    loadTasks();
  }, [entityId, lastModified, group]);

  if (!tasks || tasks.length === 0) {
    return null;
  }

  function loadTasks() {
    fetchTasksForGroup(id, entityId)
      .then((resp) => {
        if (resp.ok) {
          resp.json().then((tasks) => {
            setTasks(tasks);
          });
        } else {
          console.error(`could not load tasks of list ${name}`);
        }
      })
      .catch(() => {
        console.error(`could not load tasks of list ${name}`);
      });
  }

  return (
    <Accordion
      sx={{ flexGrow: 1 }}
      chevron={<IconChevronRight size="1rem" />}
      styles={{
        chevron: {
          '&[data-rotate]': {
            transform: 'rotate(90deg)',
          },
        },
      }}
      variant="separated"
      defaultValue="foo"
      chevronPosition="left"
    >
      <Accordion.Item value="foo">
        <Accordion.Control>{name}</Accordion.Control>
        <Accordion.Panel>
          <Stack>
            {visibleTasks.map((task) => (
              <TaskField
                key={task.id}
                task={task}
                entityId={entityId}
                onChange={(updatedTask) =>
                  setTasks((currentTasks) =>
                    currentTasks?.map((currentTask) => (currentTask.id === updatedTask.id ? updatedTask : currentTask)),
                  )
                }
              />
            ))}
            {!showCompleted && completedTasksCount > 0 && (
              <Button variant="subtle" size="xs" compact onClick={() => setShowCompleted(true)} sx={{ alignSelf: 'flex-start' }}>
                {completedTasksCount} bereits erledigte Aufgaben einblenden
              </Button>
            )}
            {showCompleted && completedTasksCount > 0 && (
              <Text
                size="xs"
                color="dimmed"
                sx={{ cursor: 'pointer' }}
                onClick={() => setShowCompleted(false)}
              >
                Erledigte Aufgaben ausblenden
              </Text>
            )}
          </Stack>
        </Accordion.Panel>
      </Accordion.Item>
    </Accordion>
  );
};
